<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-ums__memberbalancecharge">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item>
                    <el-input v-model="dataForm.mobileNumber" placeholder="会员电话" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.memberName" placeholder="会员姓名" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="dataForm.operatType" placeholder="操作类型">
                        <el-option
                                v-for="item in operatTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <template>
                        <div class="block">
                            <el-date-picker
                                    v-model="dataForm.beginDate"
                                    type="date"
                                    :clearable="true"
                                    format="yyyy年MM月dd日"
                                    value-format="yyyy-MM-dd 00:00:00"
                                    placeholder="开始时间">
                            </el-date-picker>
                        </div>
                    </template>
                </el-form-item>
                <el-form-item>
                    <template>
                        <div class="block">
                            <el-date-picker
                                    v-model="dataForm.endDate"
                                    type="date"
                                    :clearable="true"
                                    format="yyyy年MM月dd日"
                                    value-format="yyyy-MM-dd 00:00:00"
                                    placeholder="结束时间">
                            </el-date-picker>
                        </div>
                    </template>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList()">{{ $t('query') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
                </el-form-item>
                <!--        <el-form-item>-->
                <!--          <el-button v-if="$hasPermission('ums:memberbalancecharge:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>-->
                <!--        </el-form-item>-->
                <!--        <el-form-item>-->
                <!--          <el-button v-if="$hasPermission('ums:memberbalancecharge:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>-->
                <!--        </el-form-item>-->
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border
                      @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
                <!--        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>-->
                <el-table-column prop="memberName" label="会员姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="mobileNumber" label="会员电话号" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="changeNumber" label="改变数值" header-align="center"
                                 align="center"></el-table-column>
                <!--                <el-table-column prop="balance" label="余额" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="id" label="ID" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="memberId" label="会员ID" header-align="center" align="center"></el-table-column>-->
                <el-table-column prop="balanceType" label="账户类型" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.balanceType===1" type="success">现金</el-tag>
                        <el-tag v-else-if="scope.row.balanceType===2" type="success">优果</el-tag>
                        <el-tag v-else-if="scope.row.balanceType===3" type="success">乾坤袋</el-tag>
                        <el-tag v-else-if="scope.row.balanceType===4" type="success">祝福袋</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="changeType" label="改变类型" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.changeType===1" type="success">增加</el-tag>
                        <el-tag v-else-if="scope.row.changeType===2" type="success">减少</el-tag>
                    </template>
                </el-table-column>
                <!--        <el-table-column prop="note" label="流水备注" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="orderId" label="订单编号" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="creator" label="创建者" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="deptId" label="部门ID" header-align="center" align="center"></el-table-column>-->
                <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
                <!--        <el-table-column prop="updateDate" label="更新时间" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">-->
                <!--          <template slot-scope="scope">-->
                <!--&lt;!&ndash;            <el-button v-if="$hasPermission('ums:memberbalancecharge:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>&ndash;&gt;-->
                <!--&lt;!&ndash;            <el-button v-if="$hasPermission('ums:memberbalancecharge:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>&ndash;&gt;-->
                <!--          </template>-->
                <!--                </el-table-column>-->
            </el-table>
            <el-pagination
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
            </el-pagination>
            <!-- 弹窗, 新增 / 修改 -->
            <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        </div>
    </el-card>
</template>

<script>
    import mixinViewModule from '@/mixins/view-module'
    import AddOrUpdate from './memberbalancecharge-add-or-update'

    export default {
        mixins: [mixinViewModule],
        data() {
            return {
                mixinViewModuleOptions: {
                    getDataListURL: '/ums/memberbalancecharge/page',
                    getDataListIsPage: true,
                    exportURL: '/ums/memberbalancecharge/export',
                    deleteURL: '/ums/memberbalancecharge',
                    deleteIsBatch: true
                },
                operatTypes: [{
                    value: '',
                    label: ''
                }, {
                    value: '9',
                    label: '商品购买花费优果'
                }, {
                    value: '10',
                    label: '优果转账'
                }, {
                    value: '0',
                    label: '分享直推收益'
                }, {
                    value: '1',
                    label: '分享间推收益'
                }, {
                    value: '2',
                    label: '合伙人分享收益'
                }, {
                    value: '6',
                    label: '合伙人区域优果返利'
                }, {
                    value: '7',
                    label: '市场合伙人优果收益抽成'
                }, {
                    value: '13',
                    label: '寄售申诉通过'
                }, {
                    value: '15',
                    label: '买家购买优果'
                }, {
                    value: '14',
                    label: '寄售平台拒绝'
                }, {
                    value: '18',
                    label: '签到加优果'
                }, {
                    value: '19',
                    label: '系统操作'
                }, {
                    value: '23',
                    label: '清空设备优果'
                }, {
                    value: '22',
                    label: '兑换奖品'
                }],
                dataForm: {
                    mobileNumber: '',
                    balanceType: 4,
                    operatType: '',
                    beginDate: "",
                    endDate: "",
                    memberName: ""
                }
            }
        },
        components: {
            AddOrUpdate
        }
    }
</script>
